import React, { PropTypes } from 'react';
import { Jumbotron, Button, Row, FormControl, Col, ControlLabel, Glyphicon, OverlayTrigger } from 'react-bootstrap';
import Switcher from 'react-switcher';
import _ from 'lodash';
import clone from 'clone';

import { DistanceBasedCostsForm } from './DistanceBasedCostsForm';
import Avatar from './AvatarComponent';
import { gettext } from '../../../i18n/service.js';
import * as Validation from '../../../businessLogic/fieldValidation.js';
import getTooltip from '../../../businessLogic/getTooltip.js';

export default class CompanyComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.editCompany = false;
    this.companyError = {
      name: false,
      additionalPickupCost: false,
      additionalPickupPointCost: false,
      autoAssignMaxOrders: false,
      autoAssignRadius: false,
      autoAssignTime: false,
      autoAssignTimeToAccept: false,
      autoAssignTryNumber: false,
      cashOnDeliveryCap: false,
      driverReconectionTimeout: false,
      expressDeliveryCommission: false,
      notificationRadius: false,
      deliveryCommission: false,
      minimumDriverRating: false,
      radius: false,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    };
    this.error = false;
    _.bindAll(this, ['renderCompany', 'validateCompanyFields', 'updateCompany', 'resetState', 'renderEditCompany',
      'flipEditCompany', 'changeAvatar', 'findTimecode']);

    this.state = _.merge(clone(props.company), { editCompany: false });
    this.baseState = clone(props.company);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.company !== this.props.company) {
      this.setState(nextProps.company);
    }
  }

  changeAvatar(base64) {
    this.setState({ logo: base64 });
  }

  isUrl(s) {
    var regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    return regexp.test(s);
  }

  flipEditCompany() {
    this.editCompany = !this.editCompany;
    this.setState({ editCompany: !this.state.editCompany });
    //  this.resetState();
  }

  updateCompany() {
    if (this.validateCompanyFields()) {
      this.editCompany = true;
      this.setState({ editCompany: true });
      return false;
    } else {
      if (!this.isUrl(this.state.logo))
        this.props.addCompanyLogo(this.props.company.id, this.state.logo);

      this.setState({ logo: this.props.company.logo });
      this.props.startSpinner();
      this.props.updateThisCompany(this.props.company.id, this.state);
      this.props.getCompany(this.props.company.id);
      this.props.endSpinner();
      //  this.resetState();
      this.editCompany = false;
      this.setState({ editCompany: false });
    }
  }

  resetState() {
    this.setState(clone(this.props.company));
  }

  validateCompanyFields() {
    this.companyError = {
      name: false,
      additionalPickupCost: false,
      additionalPickupPointCost: false,
      autoAssignMaxOrders: false,
      autoAssignRadius: false,
      autoAssignTime: false,
      autoAssignTimeToAccept: false,
      autoAssignTryNumber: false,
      cashOnDeliveryCap: false,
      driverReconectionTimeout: false,
      expressDeliveryCommission: false,
      notificationRadius: false,
      deliveryCommission: false,
      minimumDriverRating: false,
      radius: false
    };
    this.error = false;
    if (parseFloat(this.state.cashOnDeliveryCap) < 0) {
      this.error = true;
      this.companyError.cashOnDeliveryCap = true;
    }

    if (parseFloat(this.state.additionalPickupCost) < 0) {
      this.error = true;
      this.companyError.additionalPickupCost = true;
    }

    if (parseFloat(this.state.additionalPickupPointCost) < 0) {
      this.error = true;
      this.companyError.additionalPickupPointCost = true;
    }

    if (parseFloat(this.state.autoAssignMaxOrders) < 0) {
      this.error = true;
      this.companyError.autoAssignMaxOrders = true;
    }

    if (parseFloat(this.state.autoAssignRadius) < 0) {
      this.error = true;
      this.companyError.autoAssignRadius = true;
    }

    if (parseFloat(this.state.autoAssignTime) < 0) {
      this.error = true;
      this.companyError.autoAssignTime = true;
    }

    if (parseFloat(this.state.autoAssignTimeToAccept) < 0) {
      this.error = true;
      this.companyError.autoAssignTimeToAccept = true;
    }

    if (parseFloat(this.state.autoAssignTryNumber) < 0) {
      this.error = true;
      this.companyError.autoAssignTryNumber = true;
    }

    if (parseFloat(this.state.driverReconectionTimeout) < 0) {
      this.error = true;
      this.companyError.driverReconectionTimeout = true;
    }

    if (parseFloat(this.state.expressDeliveryCommission) < 0) {
      this.error = true;
      this.companyError.expressDeliveryCommission = true;
    }

    if (parseFloat(this.state.notificationRadius) < 0) {
      this.error = true;
      this.companyError.notificationRadius = true;
    }

    if (parseFloat(this.state.deliveryCommission) < 0) {
      this.error = true;
      this.companyError.deliveryCommission = true;
    }

    if (parseFloat(this.state.minimumDriverRating) < 0) {
      this.error = true;
      this.companyError.minimumDriverRating = true;
    }

    if (parseFloat(this.state.radius) < 0) {
      this.error = true;
      this.companyError.radius = true;
    }

    if (!Validation.nameValidation(this.state.name, this.props.showMessage)) {
      this.error = true;
      this.companyError.name = true;
    }
    return this.error;
  }

  renderDriverRatingSwitcher(isEditForm) {
    return (
      <div className="switcher">
        <Switcher
          on={this.state.driverRatingEnabled}
          onClick={() => {
            const driverRatingEnabled = !this.state.driverRatingEnabled;
            this.setState({ driverRatingEnabled: driverRatingEnabled });
            this.props.updateThisCompany(this.props.company.id, { driverRatingEnabled: driverRatingEnabled });
          }} />
      </div>
    );
  }

  findTimecode(timezones) {
    const timezone = _.find(timezones, (timezone) => { return timezone.id == this.state.timezone });
    if (timezone)
      return timezone.timezoneCode;
    else
      return "";
  }

  renderCompany() {
    return (
      <div>
        <Row className="center_flex">
          <Avatar avatar={this.state.logo} changeAvatar={this.changeAvatar} />
        </Row>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COMPANY-NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.name}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('OWNER')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.props.account.name}</h4></label>
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TIME-ZONE') + ' '}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.findTimecode(this.props.timezones)}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CASH-ON-DELVIERY-CAP') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('CASH-ON-DELVIERY-CAP-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.cashOnDeliveryCap}</h4></label>
              </Col>
            </Row>

          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('BILLING-SETTINGS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('CURRENCY')}</h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.currency}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('ORDER-COST') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('TOOLTIP-ORDER-COST'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.orderCost}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('ADDITIONAL-PICKUP-COST') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('TOOLTIP-ADDITIONAL-PICKUP-COST'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.additionalPickupCost}</h4></label>
              </Col>
            </Row>
          </div>

          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DELIVERY-COMMISSION-SETTINGS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('REGULAR-COMMISSION') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('TOOLTIP-DELIVERY-COMMISSION'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.deliveryCommission}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EXPRESS-DELIVERY-COMMISSION') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('TOOLTIP-EXPRESS-COMMISSION'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.expressDeliveryCommission}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('ADDITIONAL-PICKUP-COST') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('TOOLTIP-ADDITIONAL-PICKUP-POINT-COST'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.additionalPickupPointCost}</h4></label>
              </Col>
            </Row>

          </div>

          <div className="botom_line" />

          <DistanceBasedCostsForm
            values={this.props.company.distanceBasedModifiers}
            tooltips={true} />

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DRIVER-RATING-CONTROLS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('DRIVER-RATING') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('DRIVER-RATING-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                {this.renderDriverRatingSwitcher()}
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('MINIMAL-DRIVER-RATING') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('MINIMAL-DRIVER-RATING-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.minimumDriverRating}</h4></label>
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DRIVER-CONNECTION-TIMEOUT')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TIMEOUT') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('DRIVER-CONNECTION-TIMEOUT-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.driverReconectionTimeout} {gettext('MINUTES')}</h4></label>
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DELIVERY-RESTRICTION-CONTROLS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PICK-UP-RADIUS') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('PICK-UP-RADIUS-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.radius}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NOTIFICATION-UP-RADIUS') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('NOTIFICATION-UP-RADIUS-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.notificationRadius}</h4></label>
              </Col>
            </Row>
          </div>


          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('AUTO-ASSIGN-SETINGS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('MAX-ORDERS') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('MAX-ORDERS-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.autoAssignMaxOrders}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('RADIUS') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('RADIUS-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.autoAssignRadius + ' ' + gettext('KM')}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('ASSIGN-TIME') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('ASSIGN-TIME-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.autoAssignTimeToAccept}</h4></label>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TRY-NUMBER') + ' '}
                  <OverlayTrigger placement="top" overlay={getTooltip(gettext('TRY-NUMBER-TOOLTIP'))}>
                    <Glyphicon glyph="question-sign" />
                  </OverlayTrigger>
                </h4></ControlLabel>
              </Col>
              <Col sm={6}>
                <label><h4>{this.state.autoAssignTryNumber}</h4></label>
              </Col>
            </Row>
          </div>

        </Row>
        <div className="edit_link">
          <a onClick={() => this.flipEditCompany()}><h4>{gettext('EDIT')}</h4></a>
        </div>
      </div>
    );
  }

  setIfNumber(event, oldValue, fieldldName) {
    if (isNaN(event.target.value)) {
      event.target.value = oldValue;
    } else {
      this.setState({ [fieldldName]: Number(event.target.value) });
    }
  }

  renderEditCompany() {
    return (
      <div>
        <Row className="center_flex">
          <Avatar avatar={this.state.logo} changeAvatar={this.changeAvatar} edit={true} />
        </Row>
        <Row>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('COMPANY-NAME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="text"
                  required={true}
                  value={this.state.name}
                  className={this.companyError.name ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  placeholder={gettext('COMPANY-NAME')} />
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TIME-ZONE')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl componentClass="select" name="timezone" placeholder="select"
                  onChange={(e) => this.setState({ timezone: e.target.value })}
                  value={this.state.timezone}>
                  {
                    _.map(this.props.timezones, (timezone, index) => {
                      return <option value={timezone.id} key={index}>{timezone.timezoneCode}</option>
                    })
                  }
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4> {gettext('CASH-ON-DELVIERY-CAP')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.cashOnDeliveryCap}
                  className={this.companyError.cashOnDeliveryCap ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ cashOnDeliveryCap: e.target.value })}
                  placeholder={gettext('CASH-ON-DELVIERY-CAP')} />
              </Col>
            </Row>

          </div>
          <div className="botom_line" />
          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DELIVERY-COMMISSION-SETTINGS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('REGULAR-COMMISSION')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.deliveryCommission}
                  className={this.companyError.deliveryCommission ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ deliveryCommission: e.target.value })}
                  placeholder={gettext('DELIVERY-COMMISSION')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('EXPRESS-DELIVERY-COMMISSION')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.expressDeliveryCommission}
                  className={this.companyError.expressDeliveryCommission ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ expressDeliveryCommission: e.target.value })}
                  placeholder={gettext('EXPRESS-DELIVERY-COMMISSION')} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('ADDITIONAL-PICKUP-COST')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.additionalPickupPointCost}
                  className={this.companyError.additionalPickupPointCost ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ additionalPickupPointCost: e.target.value })}
                  placeholder={gettext('ADDITIONAL-PICKUP-COST')} />
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <DistanceBasedCostsForm
            values={this.state.distanceBasedModifiers}
            isForm={true}
            companyError={this.companyError}
            onChangeCallback={(key, value) => {
              let distanceBasedModifiers = this.state.distanceBasedModifiers;
              if (distanceBasedModifiers === void 0) {
                distanceBasedModifiers = {};
              }
              distanceBasedModifiers[key] = Number(value);
              this.setState({ distanceBasedModifiers: distanceBasedModifiers });
            }} />

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DRIVER-RATING-CONTROLS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('MINIMAL-DRIVER-RATING')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.minimumDriverRating}
                  className={this.companyError.minimumDriverRating ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ minimumDriverRating: e.target.value })}
                  placeholder={500} />
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DRIVER-CONNECTION-TIMEOUT')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TIMEOUT')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.driverReconectionTimeout}
                  className={this.companyError.driverReconectionTimeout ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ driverReconectionTimeout: e.target.value })}
                  placeholder={500} />
              </Col>
            </Row>
          </div>

          <div className="botom_line" />

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('DELIVERY-RESTRICTION-CONTROLS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('PICK-UP-RADIUS')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.radius}
                  className={this.companyError.radius ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ radius: e.target.value })}
                  placeholder={50} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('NOTIFICATION-UP-RADIUS')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.notificationRadius}
                  className={this.companyError.notificationRadius ? 'company-error' : 'name'}
                  onChange={(e) => this.setState({ notificationRadius: e.target.value })}
                  placeholder={500} />
              </Col>
            </Row>
          </div>

          <div className="text_align_center margin_bottom_em">
            <h4>{gettext('AUTO-ASSIGN-SETINGS')}</h4>
          </div>
          <div className="user_data center_div">
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('MAX-ORDERS')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.autoAssignMaxOrders}
                  className={this.companyError.autoAssignMaxOrders ? 'company-error' : 'name'}
                  onChange={(e) => this.setIfNumber(e, this.state.autoAssignMaxOrders, 'autoAssignMaxOrders')}
                  placeholder={50} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('RADIUS')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.autoAssignRadius}
                  className={this.companyError.autoAssignRadius ? 'company-error' : 'name'}
                  onChange={(e) => this.setIfNumber(e, this.state.autoAssignRadius, 'autoAssignRadius')}
                  placeholder={50} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('ASSIGN-TIME')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.autoAssignTimeToAccept}
                  className={this.companyError.autoAssignTimeToAccept ? 'company-error' : 'name'}
                  onChange={(e) => this.setIfNumber(e, this.state.autoAssignTimeToAccept, 'autoAssignTimeToAccept')}
                  placeholder={500} />
              </Col>
            </Row>

            <Row>
              <Col sm={4}>
                <ControlLabel><h4>{gettext('TRY-NUMBER')}</h4></ControlLabel>
              </Col>
              <Col sm={8}>
                <FormControl
                  type="number"
                  min="0"
                  required={true}
                  value={this.state.autoAssignTryNumber}
                  className={this.companyError.autoAssignTryNumber ? 'company-error' : 'name'}
                  onChange={(e) => this.setIfNumber(e, this.state.autoAssignTryNumber, 'autoAssignTryNumber')}
                  placeholder={500} />
              </Col>
            </Row>

          </div>

        </Row>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => { this.updateCompany(); }}>{gettext('SAVE')}</Button>
          <Button bsStyle="danger" onClick={() => { this.flipEditCompany(); this.resetState(); }}>{gettext('CANCEL')}</Button>
        </div>
      </div>
    );
  }

  render() {
    return (
      <Jumbotron className="company_profile">
        <div className="item_head_title">
          <h3>{gettext('COMPANY')}</h3>
        </div>
        {!this.editCompany ? this.renderCompany() : this.renderEditCompany()}
      </Jumbotron>
    );
  }
}

CompanyComponent.propTypes = {
  company: PropTypes.object,
  account: PropTypes.object,
  addCompanyLogo: PropTypes.func,
  startSpinner: PropTypes.func,
  getCompany: PropTypes.func,
  endSpinner: PropTypes.func,
  showMessage: PropTypes.func,
  updateThisCompany: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/settings/components/CompanyComponent.js